import SlickForScreenshots from "./SlickForSceenshots";
const TwoColumnData = ({item})  => {
    
    return(
  
        <div className="process-panel tram-hts-panel">
            <h2 className="process-name tram-hts-heading">{item.cc_box_content_title}</h2>
            {item.imageUrl.length > 1? (
                <div className="tram-hts-image-slider-section ">
                    <div className="container">
                    <SlickForScreenshots screenshotContent={item.imageUrl}  dataSettings={50}/>
                    </div>
              </div>
            ):(
                <div className="tram-hts-image-section">
                    <img src={item.imageUrl} alt={item.cc_box_content_title} className="tram-hts-two-col-image" />
                </div> 
            )}
            <p className="process-desc tram-hts-two-col-content">{item.cc_box_content_content}</p>
        </div>
          
       
      
                      
                 
    );
}

export default TwoColumnData;